module.exports = {}



// WEBPACK FOOTER //
// ./src/lang/i18nKR.js